export default {
  // Default variant
  //-------------------------------------------------------------------------
  default: {
    root: "relative inline-block text-left",
    trigger:
      "h-10 inline-flex items-center justify-between gap-2 w-full rounded-full border border-bordered px-4 bg-canvas text-sm font-medium text-text outline-none focus:outline-none focus:ring-1 focus:ring-primary transition-colors",
    trigger_active: "border-primary",
    placeholder: "text-text_secondary truncate",
    label: "text-text_secondary",
    value: "text-primary font-semibold truncate",
    chevron: "w-4 h-4 shrink-0 text-text_secondary",
    clear_button: "p-0.5 -mr-1 rounded-full text-text_secondary hover:text-text transition-colors",
    backdrop: "fixed inset-0 z-[9998] bg-black/30 sm:hidden",
    panel:
      "fixed inset-x-0 bottom-0 z-[9999] rounded-t-2xl bg-canvas p-4 pb-6 shadow-lg sm:absolute sm:inset-x-auto sm:bottom-auto sm:left-0 sm:top-full sm:mt-2 sm:w-72 sm:rounded-xl sm:pb-4 sm:ring-1 sm:ring-bordered",
    panel_header: "flex items-center justify-between mb-3",
    panel_title: "text-sm font-semibold text-text",
    close_button: "p-1 -mr-1 rounded-full text-text_secondary hover:text-text hover:bg-bordered/40 transition-colors",
    modes: "grid grid-cols-3 gap-1 p-1 mb-3 rounded-full bg-bordered/40",
    mode: "h-8 rounded-full text-sm text-text_secondary hover:text-text transition-colors",
    mode_active: "bg-canvas text-text font-semibold shadow-sm",
    inputs: "flex items-center gap-2",
    input:
      "h-10 w-full min-w-0 rounded-full border border-bordered bg-canvas px-3 text-text outline-none focus:ring-1 focus:ring-primary focus:border-transparent",
    input_error: "border-error",
    separator: "text-text_secondary shrink-0",
    hint: "mt-2 text-xs text-error",
  },

  // Admin variant (matches the admin DropDownSelect)
  //-------------------------------------------------------------------------
  admin: {
    root: "relative inline-block text-left",
    trigger:
      "h-10 inline-flex items-center justify-between gap-2 w-full rounded-lg border border-admin_bordered px-4 bg-admin_paper text-sm font-medium text-admin_text outline-none focus:outline-none focus:ring-1 focus:border-admin_primary transition-colors",
    trigger_active: "border-admin_primary",
    placeholder: "text-admin_text_secondary truncate",
    label: "text-admin_text_secondary",
    value: "text-admin_primary font-semibold truncate",
    chevron: "w-4 h-4 shrink-0 text-admin_text",
    clear_button: "p-0.5 -mr-1 rounded-full text-admin_text_secondary hover:text-admin_text transition-colors",
    backdrop: "fixed inset-0 z-[9998] bg-black/30 sm:hidden",
    panel:
      "fixed inset-x-0 bottom-0 z-[9999] rounded-t-2xl bg-admin_paper p-4 pb-6 shadow-lg sm:absolute sm:inset-x-auto sm:bottom-auto sm:left-0 sm:top-full sm:mt-2 sm:w-72 sm:rounded-lg sm:pb-4 sm:shadow-md sm:ring-1 sm:ring-admin_bordered",
    panel_header: "flex items-center justify-between mb-3",
    panel_title: "text-sm font-semibold text-admin_text",
    close_button:
      "p-1 -mr-1 rounded-full text-admin_text_secondary hover:text-admin_text hover:bg-admin_canvas transition-colors",
    modes: "grid grid-cols-3 gap-1 p-1 mb-3 rounded-lg bg-admin_canvas",
    mode: "h-8 rounded-md text-sm text-admin_text_secondary hover:text-admin_text transition-colors",
    mode_active: "bg-admin_paper text-admin_text font-semibold shadow-sm",
    inputs: "flex items-center gap-2",
    input:
      "h-10 w-full min-w-0 rounded-lg border border-admin_canvas bg-admin_canvas px-3 text-admin_text outline-none focus:ring-1 focus:ring-admin_primary focus:border-transparent",
    input_error: "border-admin_error",
    separator: "text-admin_text_secondary shrink-0",
    hint: "mt-2 text-xs text-admin_error",
  },
}
